import Image from 'next/image';
import React from 'react';

const Tab = ({ label, active, onClick }) => {
  return (
    <div className="p-4 pb-0 cursor-pointer relative" onClick={onClick}>
      <div className="flex items-center">
        <div className="">
          <p
            className={`transition-all  duration-500 ease-linear ${
              active ? ' text-primary font-bold' : 'text-neutral-mid-80'
            }`}
          >
            {label || 'All'}
          </p>
        </div>
      </div>
      {active && (
        <div
          className={`h-[1px] ${
            active
              ? 'border-primary  transition-border duration-1000 ease-in'
              : 'border-neutral-light-50 transition-all duration-500 ease-in-out'
          } border-b-2 bottom-0 absolute `}
        ></div>
      )}
    </div>
  );
};

export default Tab;
